export default {
    data() {
        return {
            fields: {
                inn: 'ИНН',
                ogrn: 'ОГРН',
                kpp: 'КПП',
                name: 'Название',
                address: 'Адрес',
            }
        }
    },
    props: {
        orgData: {
            type: String,
            default: ''
        }
    },
    mounted() {},
    template: `<div v-html="orgData"></div>`
};
